<template>
  <div class="signup">
    <slot name="header"/>
    <div class="intake-container">
      <div class="title">{{ title }}</div>
      <div class="subTitle">{{ subTitle }}</div>
      <enter-details :action="buttonAction"
                     :error="error"
                     :reset-error="resetError"
                     :button-title="buttonTitle"/>
      <slot name="information-details"/>
      <div class="privacy-message">לעולם לא נמסור את הפרטים שלך לאף צד שלישי.</div>
      <div class="action" v-on:click="goToLogin">
           כבר הצטרפת לשירות?
        <div class="action-link"> הכניסה מכאן</div>
      </div>
      <support-footer/>
    </div>
  </div>
</template>

<script>

import BaseUI from 'base-ui';
import EnterDetails from '@/base-components/EnterDetails';

export default {
  name: 'Signup',
  components: {
    EnterDetails,
    SupportFooter: BaseUI.SupportFooter,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: true,
    },
    buttonTitle: {
      type: String,
      required: true,
    },
    buttonAction: {
      type: Function,
      required: true,
    },
    error: {
      type: String,
      required: true,
    },
    resetError: {
      type: Function,
      required: true,
    },
  },
  methods: {
    goToLogin() {
      window.location.href = '/sr';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../node_modules/base-ui/src/scss/riseup-colors';
@import '../scss/mixins';

.signup {
  @include white-page-frame;

  .intake-container {
    @include responsive-padding;
    margin-top: 30px;

    .generate-code-button {
      width: 100%;
    }

    .title {
      font-family: SimplerPro;
      font-weight: bold;
      font-size: 24px;
      line-height: 1.2;
      display: inline-block;
      width: 100%;
      margin-bottom: 5px;
    }

    .subTitle {
      font-size: 18px;
      color: $riseup_black;
      line-height: 1.5em;
      margin-bottom: 32px;

      .wa-verification {
        font-weight: bold;
      }
    }

    .action {
      display: flex;
      margin: 30px 0px 20px;
      color: $riseup_light_blue;
      font-size: 16px;
      text-align: center;
      .action-link {
        font-weight: bold;
        cursor: pointer;
        text-decoration: underline;
        margin-right: 5px;
      }
    }
    .privacy-message {
      font-size: 16px;
      color: $riseup_black;
      line-height: 24px;
      margin: 30px 0 15px;
    }
  }
}

</style>
